// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class CountriesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicCountries';
        this.Server = this.props.context.getState().server.publicCountries;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'countryCode'];
        this.showDatePicker = false;

        const defaultHead = [
            { id: 'name', label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
            { id: 'countryCode', label: 'countryCode', alignRight: false, cell: 'Text', displayGrid: true },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
